import React from 'react';
import "animate.css/animate.min.css";
import '../components/HeroSection.css';

const Contact = () => {
  return (
    <footer className="slide-in-element mt-32" aria-label="Site Footer">
        
    </footer>
  );
};

export default Contact;
